import * as React from "react";
import { push } from "connected-react-router";
import * as _ from "lodash";
import { connect } from "react-redux";
import styled from "styled-components";
import { Row, Col, Button } from "antd";
import moment from "moment";

import {
  updateOrder,
  resetOrder,
  resetQuote,
  fetchQuoteAsync,
  selectMultiType,
  updateSinglePoint,
  updateMultiPoints,
  addPoint,
  deletePoint
} from "../actions";
import { MainComponentContainer } from "../../../shared/MainComponentContainer";
import { EntryComponentContainer } from "../../../shared/EntryComponentContainer";
import RowWrapper from "../../../shared/RowWrapper";
import DayInput from "../../../shared/DayInput";
import { ExtrasPicker } from "../../../shared/ExtrasPicker";
import { PriceDisplay } from "../../../shared/PriceDisplay";
import { RootState } from "../../../store/rootReducer";
import { QuoteRequest } from "../../../lib/model/QuoteRequest";
import { BookMultiOrder } from "../model/BookMultiOrder";
import { fetchAddressesAsync } from "../../addresses/actions";
import { MultiTypeSelect } from "./MultiTypeSelect";
import { TourType } from "../../../lib/model/TourType";
import { SinglePointComponent } from "./SinglePointComponent";
import { MultiPointComponent } from "./MultiPointComponent";
import { Load } from "../../../lib/model/Load";
import { AddressState } from "../../../lib/model/AddressState";

const EntryHeadline = styled.span`
  color: #061a32;
  font-size: 14px;
  line-height: 17px;
  font-weight: 400;
`;

const Label = styled.span`
  color: #061a32;
  font-size: 11px;
  line-height: 32px;
  font-weight: 300;
`;

const DayPickerWrapper = styled(Row)`
  margin-bottom: -44px;

  @media only screen and (max-width: 576px) {
    margin-bottom: 0;
  }
`;

const mapStateToProps = (state: RootState) => ({
  order: state.bookMulti.order,
  isLoadingQuote: state.bookMulti.isLoadingQuote,
  quote: state.bookMulti.quote,
  addresses: state.addresses.addresses,
  isLoadingAddresses: state.addresses.isLoadingAddresses,
  error: state.bookMulti.quoteError
});

const dispatchProps = {
  selectMultiType,
  fetchQuote: fetchQuoteAsync.request,
  push,
  updateOrder,
  resetOrder,
  resetQuote,
  fetchAddresses: fetchAddressesAsync.request,
  updateSinglePoint,
  updateMultiPoints,
  addPoint,
  deletePoint
};

type Props = ReturnType<typeof mapStateToProps> & typeof dispatchProps;

class BookMultiContainer extends React.Component<Props> {
  render() {
    const {
      order,
      isLoadingQuote,
      quote,
      updateOrder,
      selectMultiType,
      resetOrder,
      updateSinglePoint,
      updateMultiPoints
    } = this.props;
    const { singlePoint, multiPoints } = order;
    return (
      <>
        {!!order.type ? (
          <MainComponentContainer>
            <RowWrapper type="flex">
              <Col span={24}>
                <Row type="flex">
                  <Col
                    span={24}
                    style={{ textAlign: "right", marginBottom: 10 }}
                  >
                    <Button
                      onClick={resetOrder}
                      style={{ border: "none !important" }}
                    >
                      Multi-Stopp Typ ändern
                    </Button>
                  </Col>
                  <Col span={24}>
                    <EntryComponentContainer>
                      <DayPickerWrapper type="flex">
                        <Col span={24}>
                          <EntryHeadline>Datum</EntryHeadline>
                        </Col>
                        <Col span={24}>
                          <Label>* Tag der Fahrt</Label>
                        </Col>
                      </DayPickerWrapper>
                      <Row
                        type="flex"
                        justify="space-around"
                        style={{ marginBottom: "8px" }}
                      >
                        <Col span={10} md={10} sm={14} xs={18}>
                          <DayInput
                            value={order.date ? moment(order.date) : undefined}
                            onChange={value =>
                              updateOrder({
                                ...order,
                                date: value ? value.toISOString() : undefined
                              })
                            }
                          />
                        </Col>
                      </Row>
                    </EntryComponentContainer>
                  </Col>
                </Row>
                {order.type === TourType.Distribution && (
                  <>
                    <SinglePointComponent
                      title="Beladung"
                      inputTitle="* Beladestelle"
                      point={singlePoint}
                      onChange={updateSinglePoint}
                    />
                    <MultiPointComponent
                      title="Entladung"
                      inputTitle="* Entladestelle"
                      addPointButtonTitle="Entladestelle hinzufügen"
                      points={multiPoints}
                      onChange={updateMultiPoints}
                      onAddPoint={this.props.addPoint}
                      onDeletePoint={this.props.deletePoint}
                    />
                  </>
                )}
                {order.type === TourType.Collection && (
                  <>
                    <MultiPointComponent
                      title="Beladung"
                      inputTitle="* Beladestelle"
                      addPointButtonTitle="Beladestelle hinzufügen"
                      points={multiPoints}
                      onChange={updateMultiPoints}
                      onAddPoint={this.props.addPoint}
                      onDeletePoint={this.props.deletePoint}
                    />
                    <SinglePointComponent
                      title="Entladung"
                      inputTitle="* Entladestelle"
                      point={singlePoint}
                      onChange={updateSinglePoint}
                    />
                  </>
                )}
                <Row type="flex" gutter={21}>
                  <Col span={12} md={12} xs={24}>
                    <EntryComponentContainer>
                      <EntryHeadline>Fahrzeugoptionen</EntryHeadline>
                      <ExtrasPicker
                        activeValues={order.extras}
                        onChange={value =>
                          updateOrder({ ...order, extras: value })
                        }
                      />
                    </EntryComponentContainer>
                  </Col>
                  <Col span={12} md={12} xs={24} style={{ display: "flex" }}>
                    <EntryComponentContainer>
                      <EntryHeadline>Festpreis</EntryHeadline>
                      <PriceDisplay
                        isLoading={isLoadingQuote}
                        quote={quote || undefined}
                        continueEnabled={
                          isValidOrder(order) && !!this.props.quote
                        }
                        onContinueClicked={this.handleContinueClicked}
                        error={this.props.error || undefined}
                      />
                    </EntryComponentContainer>
                  </Col>
                </Row>
              </Col>
            </RowWrapper>
          </MainComponentContainer>
        ) : (
          <RowWrapper type="flex">
            <Col span={24}>
              <MultiTypeSelect onSelect={selectMultiType} />
            </Col>
          </RowWrapper>
        )}
      </>
    );
  }
  componentDidMount = () => {
    this.props.fetchAddresses();
  };
  componentDidUpdate = (prevProps: Props, prevState: {}, snapshot: any) => {
    const order = this.props.order;
    if (isValidOrder(order)) {
      if (!_.isEqual(prevProps.order, order)) {
        this.props.fetchQuote(QuoteRequest.requestForMultiOrder(order));
      }
    } else {
      this.props.resetQuote();
    }
  };
  handleContinueClicked = () => {
    this.props.push("/multisummary");
  };
}

const isValidOrder = (order: BookMultiOrder): boolean => {
  const loadsValid = order.multiPoints
    .flatMap(p => p.loads)
    .reduce((acc, load) => acc && isValidLoad(load), true);
  const addressesValid = [
    order.singlePoint.address,
    ...order.multiPoints.map(p => p.address)
  ].reduce((acc, state) => acc && isValidAddressState(state), true);
  return !!order.date && loadsValid && addressesValid;
};

const isValidLoad = (load: Load): boolean => {
  return (
    load.count > 0 && load.height > 0 && load.width > 0 && load.totalWeight > 0
  );
};

const isValidAddressState = (state: AddressState): boolean => {
  return (
    !!state.id ||
    (state.create &&
      !!state.create.companyName &&
      state.create.companyName.length > 1 &&
      !!state.create.street &&
      state.create.street.length > 1 &&
      !!state.create.houseNumber &&
      state.create.houseNumber.length > 0 &&
      !!state.create.validatedZip &&
      state.create.validatedZip.isSupported) ||
    false
  );
};

export default connect(
  mapStateToProps,
  dispatchProps
)(BookMultiContainer);
